import React from 'react';

import Image from './image/Image';
import FullGallery from './fullGallery/FullGallery';

import styles from './Gallery.module.scss';


// images props should be like in below example:
// [
//   { id: 0, img: 'path_to_img', },
//   { id: 1, img: 'path_to_img', },
//   { id: 3, img: 'path_to_img', },
// ]

class Gallery extends React.Component {
  static defaultProps = {
    className: '',
    images: [],
  };

  state = {
    show: false,
    selectedImage: undefined,
  }

  onClickImage = (image) => {
    this.setState({
      show: true,
      selectedImage: image,
    })
  }

  onSelectImage = (image) => {
    this.setState({
      selectedImage: image,
    });
  }

  onCloseFullGallery = () => {
    this.setState({
      show: false,
    });
  }

  render() {
    const galleryClasses = [styles.Gallery, this.props.className];

    return (
      <div className={galleryClasses.join(' ')}>
        {this.props.images.map((image) => {
          return (
            <Image key={image.id} src={image.imgThumb} onClick={() => this.onClickImage(image)}/>
          );
        })}
        {this.state.show &&
          <FullGallery selectedImage={this.state.selectedImage}
                       onSelectImage={this.onSelectImage}
                       onClose={this.onCloseFullGallery}
                       images={this.props.images}/>}
      </div>
    );
  }
}

export default Gallery;
